<template>
    <div class="vehicle-mileage-logger two-wide-mobile" v-if="hasVehicle" :class="{success:success}">
        <heading colour="white" size="medium">Log Mileage For {{ vehicle.vrn }} ( {{ vehicle.make }} {{ vehicle.model }} )</heading>
        <p><strong>Current Mileage:</strong> {{ vehicle.mileage }}</p>
        <p class="mt-2"><strong>New Mileage:</strong> <input type="number" class="text-gray-900" v-model="new_mileage" /></p>
        <ui-button colour="white" class="mt-4" @click.prevent="submitMileage()">Submit New Mileage</ui-button>
    </div>
</template>

<script>
    export default {
        components: {},
        props:['vehicleId'],
        data() {
            return {
                vehicle: null,
                new_mileage: null,
                success:null
            }
        },
        computed: {
            hasVehicle: function(){
                return _.isObject(this.vehicle);
            }
        },
        watch: {},
        methods: {
            getVehicle() {
                var that = this;

                axios.get(appUrls.vehicles.show.replace('REPLACEME',this.vehicleId))
                    .then(function (response) {
                        that.vehicle = response.data.data;
                    });
            },
            submitMileage(){
                var that = this;

                if( _.isNull(this.new_mileage) || parseInt(this.new_mileage,10) <= 0)
                {
                    return;
                }

                axios.post(appUrls.vehicles.mileage.update.replace('REPLACEME',this.vehicleId),{ mileage:this.new_mileage })
                    .then(function (response) {
                        that.vehicle = response.data.data;
                        that.new_mileage = null;
                        that.success = true;
                        window.setTimeout(function(){
                            that.success = null;
                        },2000);
                    });
            }
        },
        mounted() {
            this.getVehicle();
        }
    }
</script>

<style lang="scss" scoped>
    .vehicle-mileage-logger {
        @include clearfix();
        background-color: $brand;
        margin-bottom: 1em;
        border-radius: $standardBorderRadius;
        padding: 1em;
        font-size: 1em;
        color: #FFF;
        position: relative;
        transition:all 1s ease-in-out;
        &.success{
            background-color:#0b7247;
        }
        input{
            width: 300px;
            max-width: 100%;
            display: inline;
            @include mobile(){
                display:block;
                width:100%;
            }
        }
        strong{
            width: 160px;
            display: inline-block;
            @include mobile(){
                display:block;
                width:100%;
            }
        }
        h1{
            color:#FFF;
        }
        a{
            padding: 0.5em 0.8em;
            background-color: #FFF;
            border-radius: $standardBorderRadius;
            color: $brand;
            margin: 0.2em 0 0 0;
            display: inline-block;
            text-decoration: none;
            transition:all 0.1s ease-in-out;
            float:right;
            &:hover{
                background-color: #E4F6FF;
            }
        }
    }
</style>
